<template>
  <div class=" is-fullwidth">
    
   

    <div class="is-pulled-right">
        
      <button @click="exportXLS()" class="button is-info ml-2 " >Export</button>
    </div>
    <div class="is-pulled-right "><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="is-pulled-right mr-4">
      <button class="button" :class="{'is-link':this.range_id == ''}" :disabled="this.loading==true" @click="setRangeId('')">ALL</button>
      <button class="button" :class="{'is-link':this.range_id == 1}" :disabled="this.loading==true" @click="setRangeId(1)">Jerseys</button>
      <button class="button" :class="{'is-link':this.range_id == 3}" :disabled="this.loading==true" @click="setRangeId(3)">Shorts</button>
      <button class="button" :class="{'is-link':this.range_id == 2}" :disabled="this.loading==true" @click="setRangeId(2)">LW</button>
    </div> 
     
     
    <div class="buttons">
      <button class=" button  is-light mr-4" @click="sidebarVisible = !sidebarVisible">Toggle Menu</button>
          <button class="button " :disabled="loading==true" v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
        
       
      </div>

      <div v-if="loading === true">
                <div class="notification is-info">Loading orders ...</div>
      </div>

      <table class="table is-fullwidth" id="summarytable" v-if="loading === false">
        <thead>
            <tr>
              <th>Order Type</th>
              <th v-for="row in summary_planner_weeks" :key="row.id">{{ row.date | formatUKDate }}</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td>Total Orders</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberOrders(row.date) }}</td>
                <td>{{ totalOrders }}</td>
              </tr>
              <tr>
                <td>Total Garments</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberGarments(row.date) }}</td>
                <td>{{ total_garments }}</td>
              </tr>
               <tr>
                <td>Equivalent Jerseys</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberGarmentsEquivalent(row.date) }}</td>
                <td>{{ total_garments_equivalent }}</td>
              </tr>
              <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Total <span class="has-text-danger">Urgent</span> Orders</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberUrgentOrders(row.date) }}</td>
                <td>{{ totalUrgentOrders }}</td>
              </tr>
              <tr>
                <td>Total Urgent Garments</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberUrgentGarments(row.date) }}</td>
                <td>{{ totalUrgentGarments }}</td>
              </tr>
               <tr>
                <td>Equivalent Jerseys</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberUrgentGarmentsEquivalent(row.date) }}</td>
                <td>{{ total_urgent_garments_equivalent }}</td>
              </tr>
               <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Total <span class="has-text-link">Shorts</span> Orders</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberShortsOrders(row.date) }}</td>
                <td>{{ totalShortsOrders }}</td>
              </tr>
              <tr>
                <td>Total Shorts Garments</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberShortsGarments(row.date) }}</td>
                <td>{{ totalShortsGarments }}</td>
              </tr>
               <tr>
                <td>Equivalent Jerseys</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberShortsGarmentsEquivalent(row.date) }}</td>
                <td>{{ total_shorts_garments_equivalent }}</td>
              </tr>
              <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Total <span class="has-text-primary">Jerseys</span> Orders</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberJerseysOrders(row.date) }}</td>
                <td>{{ totalJerseysOrders }}</td>
              </tr>
              <tr>
                <td>Total Jerseys Garments</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberJerseysGarments(row.date) }}</td>
                <td>{{ totalJerseysGarments }}</td>
              </tr>
               <tr>
                <td>Equivalent Jerseys</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberJerseysGarmentsEquivalent(row.date) }}</td>
                <td>{{ total_jerseys_garments_equivalent }}</td>
              </tr>
              <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Total Other Garments Orders</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberOtherGarmentsOrders(row.date) }}</td>
                <td>{{ totalOtherGarmentsOrders }}</td>
              </tr>
              <tr>
                <td>Total Other Garments</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberOtherGarments(row.date) }}</td>
                <td>{{ totalOtherGarments }}</td>
              </tr>
               <tr>
                <td>Equivalent Jerseys</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ numberOtherGarmentsEquivalent(row.date) }}</td>
                <td>{{ total_other_garments_equivalent }}</td>
              </tr>
               <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Total equivalent jerseys to be printed</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ totalEquivalentJerseysToBePrinted(row.date) }}</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Capacity</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">
                  <label class="is-sr-only" :for="'capacity-' + row.date">Capacity for {{ row.date | formatUKDate }}</label>
                  <input
                    :id="'capacity-' + row.date"
                    type="text"
                    class="input is-small"
                    :value="getCapacityForWeek(row.date)"
                    @input="setCapacityForWeek(row.date, $event.target.value)"
                  />
                </td>
                <td>-</td>
              </tr>
             <tr>
                <td>Remaining Capacity</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">{{ remainingCapacityForWeek(row.date) }}</td>
                <td>-</td>
              </tr>
              <tr>
                <td>---</td>
                <td v-for="row in summary_planner_weeks" :key="row.id">-</td>
                <td>-</td>
              </tr>
            </tbody>
      </table>


    <table class="table is-hoverable is-fullwidth" id="orderstableexcel" style="display:none">
    	<thead>
        <tr>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th  >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Garment</th>
          <th>Design</th>

          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          <th>Equivalent Qty</th>
          <th>Artwork</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
          <th>Week</th>
            <th>Notes</th>
        </tr>
    	</thead>
    	<tbody>
		    
        <template v-for="row in planner_weeks">
            <tr  :key="row.date" class="is-selected">
              <th colspan="16">Week Commencing {{ row.date_formatted }} - {{ numberOrders(row.date)}} orders / {{ numberGarments(row.date)}} garments <span v-if="selected_location_id==2"> / {{ numberGarmentsEquivalent(row.date)}} equivalent jerseys</span></th>
            </tr>
            <tr v-for="order in orderedOrders[row.date]" :key="'xls' + order.orderID" >
            
           
         
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          <td>{{ Math.ceil(order.total_qty / order.jersey_multiplier) }}</td>
          <td>
            <span class="" v-if="order.artwork_completed == 1">
                Complete
            </span>
            <span class="" v-else-if="order.artwork_finished == 1">
                Finished
            </span>
          </td>
          <td>
              <span  v-if="order.artwork_printed_paper == 1">
                Yes
            </span>
          </td>
          
          <td>
            <span  v-if="order.artwork_printed_rolls == 1">
                Yes
            </span>
            

          </td>
          <td>
<span  v-if="order.digital_print_cutting == 1">
                Yes
            </span>
            

          </td>
          <td>{{  order.printing_planner_date }}</td>
          <td><span v-if="order.print_planner_notes != null">{{ order.print_planner_notes.notes }}</span></td>
             
			</tr>
      </template>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" style="display:none" class="button is-info" v-if="loading==false">Export to Excel</button>
    
    <div id="modal-ter" class="modal " :class="{'is-active': showModal}" >
      
      <div class="modal-background"></div>
        <div class="modal-card" style="width:900px">
          <header class="modal-card-head">
            <p class="modal-card-title">Update Order Notes - {{  selectedPONumber }} </p>
            <button class="delete" aria-label="close" @click="showModal=false"></button>
          </header>
          <section class="modal-card-body">
            <form @submit.prevent="updateNotes()">
            <div class="field">
            <textarea class="textarea" placeholder="Enter notes here ..." v-model="selectedNotes"></textarea>
          </div>
            <div class="field ">
              <div class="control">
                <button class="button is-success" :disabled="working==true">Save</button>
              </div>
              
            </div>
            </form>
            
          </section>
          </div>
          
        </div>

  </div>

  
</template>

<script>
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';


export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      order_by: 'printing_urgent DESC,printing_planner_date ASC,deliverydate ASC',
      search: '',
      selected_location_id:0,
      limit: '',
      accessToken: '',
      start_date: '',
      planner_weeks: [],
      range_id: '',
      selectedNotes: '',
      selectedPONumber: '',
      selectedOrder: [],
      selectedOrderIDs: [],
      show_week: '',
      weeklyCapacity: {}
      
    }
  },
   methods: {
   
    showNotesModal(order)
      {
        if( order.print_planner_notes != null)
        {
            this.selectedNotes = order.print_planner_notes.notes
        }
        else {
          this.selectedNotes = ''
        }
        this.selectedPONumber = order.ponumber
        this.selectedOrder = order
        this.showModal = true
    },
    updateNotes()
    {
      this.working = true

        var formdata = { 
             order_id: this.selectedOrder.orderID,
             notes : this.selectedNotes
        }; 

        OrderService.updatePrintPlannerNotes(this.accessToken, formdata)
        .then(() => {
            if(this.selectedOrder.print_planner_notes == null)
            {
              this.selectedOrder.print_planner_notes = []
              this.selectedOrder.print_planner_notes.notes = this.selectedNotes
            } 
            else { 
              this.selectedOrder.print_planner_notes.notes = this.selectedNotes
            }
           
            this.working = false
            this.showModal = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error));
            this.working = false
        });
    },
    numberOrders(dateToCheck) {
      return this.isObjectAvailable(dateToCheck) ? Object.keys(this.orderedOrders[dateToCheck]).length : 0;
    },
    getPrintLocationName(id) {
      const locationId = Number(id);

      if (locationId === 1) {
        return 'Strabane';
      }
      if (locationId === 2) {
        return 'Giurgiu';
      }
      if (locationId === 26) {
        return 'Metropolis';
      }

      return 'Unknown';
    },
    numberGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + order.total_qty, 0);
      }
      else {
        return 0
      }
    },
    numberGarmentsEquivalent(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + Math.ceil(order.total_qty / order.jersey_multiplier), 0);
      }
      else {
        return 0
      }
    },
    numberUrgentOrders(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].filter(order => Number(order.printing_urgent) === 1).length;
      }
      else {
        return 0
      }
    },
    numberUrgentGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (Number(order.printing_urgent) === 1 ? order.total_qty : 0), 0);
      }
      else {
        return 0
      }
    },
    numberUrgentGarmentsEquivalent(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (Number(order.printing_urgent) === 1 ? Math.ceil(order.total_qty / order.jersey_multiplier) : 0), 0);
      }
      else {
        return 0
      }
    },
    numberShortsOrders(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].filter(order => order.range === 'Shorts').length;
      }
      else {
        return 0
      }
    },
    numberShortsGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (order.range === 'Shorts' ? order.total_qty : 0), 0);
      }
      else {
        return 0
      }
    },
    numberShortsGarmentsEquivalent(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (order.range === 'Shorts' ? Math.ceil(order.total_qty / order.jersey_multiplier) : 0), 0);
      }
      else {
        return 0
      }
    },
    numberJerseysOrders(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].filter(order => order.range === 'Jerseys').length;
      }
      else {
        return 0
      }
    },
    numberJerseysGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (order.range === 'Jerseys' ? order.total_qty : 0), 0);
      }
      else {
        return 0
      }
    },
    numberJerseysGarmentsEquivalent(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (order.range === 'Jerseys' ? Math.ceil(order.total_qty / order.jersey_multiplier) : 0), 0);
      }
      else {
        return 0
      }
    },
    isOtherGarmentRange(orderRange) {
      return orderRange !== 'Jerseys' && orderRange !== 'Shorts';
    },
    numberOtherGarmentsOrders(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].filter(order => this.isOtherGarmentRange(order.range)).length;
      }
      else {
        return 0
      }
    },
    numberOtherGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (this.isOtherGarmentRange(order.range) ? order.total_qty : 0), 0);
      }
      else {
        return 0
      }
    },
    numberOtherGarmentsEquivalent(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + (this.isOtherGarmentRange(order.range) ? Math.ceil(order.total_qty / order.jersey_multiplier) : 0), 0);
      }
      else {
        return 0
      }
    },
    totalEquivalentJerseysToBePrinted(dateToCheck) {
      return this.numberUrgentGarmentsEquivalent(dateToCheck)
        + this.numberShortsGarmentsEquivalent(dateToCheck)
        + this.numberJerseysGarmentsEquivalent(dateToCheck)
        + this.numberOtherGarmentsEquivalent(dateToCheck);
    },
    isObjectAvailable(dateToCheck) {
      return this.orderedOrders[dateToCheck] && Object.keys(this.orderedOrders[dateToCheck]).length > 0;
    },
    getCapacityForWeek(weekDate) {
      if (this.weeklyCapacity[weekDate] === undefined) {
        this.$set(this.weeklyCapacity, weekDate, '30000');
      }
      return this.weeklyCapacity[weekDate];
    },
    setCapacityForWeek(weekDate, value) {
      this.$set(this.weeklyCapacity, weekDate, value);
    },
    remainingCapacityForWeek(dateToCheck) {
      const capacity = Number(this.getCapacityForWeek(dateToCheck)) || 0;
      return capacity - this.totalEquivalentJerseysToBePrinted(dateToCheck);
    },
    setRangeId(newValue) {
      this.range_id = newValue
      //this.getOrders();
    },
      async getOrders() {
        if(this.selected_location_id > 0 && this.accessToken != '')
        {
          this.loading=true
          this.selectedOrderIDs = []
          this.orders = []
          OrderService.getPrintingCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date, this.range_id, 0)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
        }
        else{
          this.orders = []
          this.loading = false
        }
      },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             artwork_printed_paper: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.artwork_printed_paper = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updatePlannerWeek(order) {
        this.working = true

        // Check if it's a multi-move
        if(this.selectedOrderIDs.length > 0)
        {
          if(confirm("Are you sure you want to update all selected orders ?"))
            {
              var formdata1 = { 
                  _method: 'patch',
                  field_to_set: 'printing_planner_date',
                  value: order.printing_planner_date,
                  order_ids: this.selectedOrderIDs //JSON.stringify()
              }; 

              OrderService.updateMultiOrder(this.accessToken, formdata1)
              .then(() => {
                  
                  this.working = false
                  this.getOrders();
                  // Remove the orders from this screen
              }).catch((error) => {
                alert("Something went wrong and the order has not been updated. Please reload and try again")
                  console.log("Error:" + JSON.stringify(error.response.data));
                  this.working = false
              });
          }
          else {
            this.working = false
          }
        }
        else {

          var order_id = order.orderID

          var formdata = { 
              _method: 'patch',
              printing_planner_date: order.printing_planner_date
          }; 

          OrderService.updateOrder(this.accessToken, order_id, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
    },
    async updateCuttingType(order) {
        this.working = true

          var order_id = order.orderID

          var formdata = { 
              _method: 'patch',
              cutting_type_multi: order.cutting_type_multi
          }; 

          OrderService.updateOrder(this.accessToken, order_id, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        
    },
    
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&restrict_by_user=1").then(
               response => this.locations = response 
            );
      },
      async getPlannerWeeks() {
        if(this.accessToken != "")
        {
          UtilityService.getSimpleApiData(this.accessToken, "planner_weeks?printing=1&location_id=" + this.selected_location_id).then(
                response => this.planner_weeks = response 
              );
        }
      },
      exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstableexcel'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Print Planner.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(row) {
            //if(  u.artwork_printed_paper == 0) 
           // {
               console.log(row)
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     filtered_planner_weeks: function() {
      let show_week = this.show_week;

        if(show_week != '')
        {
           return this.planner_weeks.filter(function(u) {
            return u.date == show_week;
          });
        }
        else {
            return this.planner_weeks
        }
        
     },
      summary_planner_weeks: function() {
        return this.filtered_planner_weeks.filter(week => this.isObjectAvailable(week.date));
      },
      totalOrders: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberOrders(week.date), 0);
      },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     },
      total_garments_equivalent: function () {
        return this.filteredOrders.reduce((total, order) => total + Math.ceil(order.total_qty / order.jersey_multiplier), 0);
      },
      totalUrgentOrders: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberUrgentOrders(week.date), 0);
      },
      totalUrgentGarments: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberUrgentGarments(week.date), 0);
      },
      total_urgent_garments_equivalent: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberUrgentGarmentsEquivalent(week.date), 0);
      },
      totalShortsOrders: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberShortsOrders(week.date), 0);
      },
      totalShortsGarments: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberShortsGarments(week.date), 0);
      },
      total_shorts_garments_equivalent: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberShortsGarmentsEquivalent(week.date), 0);
      },
      totalJerseysOrders: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberJerseysOrders(week.date), 0);
      },
      totalJerseysGarments: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberJerseysGarments(week.date), 0);
      },
      total_jerseys_garments_equivalent: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberJerseysGarmentsEquivalent(week.date), 0);
      },
      totalOtherGarmentsOrders: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberOtherGarmentsOrders(week.date), 0);
      },
      totalOtherGarments: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberOtherGarments(week.date), 0);
      },
      total_other_garments_equivalent: function() {
        return this.summary_planner_weeks.reduce((total, week) => total + this.numberOtherGarmentsEquivalent(week.date), 0);
      },
     orderedOrders() {
        // Use reduce to organize orders by date
        const organizedOrders =  this.filteredOrders.reduce((result, order) => {
          const date = order.printing_planner_date;
          if (!result[date]) {
            result[date] = [];
          }
          result[date].push(order);
          return result;
        }, {});

        return organizedOrders
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
           this.getPlannerWeeks();
        });
  },
 
  mounted() {
    

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = ""
    }

    if (localStorage.print_planner_range_id) {
      this.range_id = localStorage.print_planner_range_id;
    }
    else{
      this.range_id = ""
    }

    
  },
   watch: {
    'selected_location_id'() {
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getPlannerWeeks();
      this.getOrders();
    },
    'range_id'() {
      localStorage.print_planner_range_id = this.range_id
      this.getPlannerWeeks();
      this.getOrders();
    },
   
  }
}


</script>

<script setup>
import { inject } from 'vue'

const sidebarVisible = inject('sidebarVisible')

if (!sidebarVisible) {
  console.warn('sidebarVisible not injected!')
}


</script>

